import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { LocatiiService } from '../locatii.service';
import { LocatieUpdate } from '../locatii.interface';

@Component({
    selector: 'app-edit-locatii',
    templateUrl: './edit-locatii.component.html',
    styleUrls: ['./edit-locatii.component.scss']
})
export class EditLocatiiComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, Validators.required),
        address: new FormControl(this.data.address, Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditLocatiiComponent>,
        private locatiiService: LocatiiService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, address } = this.form.value as LocatieUpdate;

        const updatedModul: LocatieUpdate = {
            name,
            address,
            id: this.data.id,
        };

        this.locatiiService
            .update(updatedModul)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
